import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/arrow-up.svg';

export const IconArrowUp: IconComponent = props => <Icon {...props} src={src} />;
